import type { FC, ReactNode } from 'react'
import { useState } from 'react'

import type { ButtonProps } from '@app/components/ui/button'
import { Button } from '@app/components/ui/button'
import { useStore } from '@app/store'
import { MetricCorrelations } from '@graphql/documents/metric.graphql'

type ChildFunc = (props: Partial<ButtonProps>) => ReactNode

interface Props {
  metricId: string
  strategyId: string | null
  children?: ChildFunc
}

const defaultChildren: ChildFunc = (buttonProps) => (
  <Button aria-label="load correlations" {...buttonProps}>
    Load correlations
  </Button>
)

const LoadCorrelationsButton: FC<Props> = ({ metricId, strategyId, children = defaultChildren, ...rest }) => {
  const [loading, setLoading] = useState(false)
  const loaderQuery = useStore.use.loaderQuery()

  const onClick = async () => {
    setLoading(true)

    try {
      await loaderQuery(MetricCorrelations, { id: metricId, strategyId })
    } finally {
      setLoading(false)
    }
  }

  return children({ loading, onClick, ...rest })
}

export default LoadCorrelationsButton
